import 'foundation-sites';
import $ from 'jquery';

$(() => Foundation.MediaQuery._init());

$(window).on('load', () => {
  $(document).foundation();
});
